module.exports = __webpack_public_path__ + "img/seloMedalhaBronzeSombra.58aa2b7d.png";